

import storage from "@/storage";
import { ReportFilter } from "../../services";
import { ReportTableComponent } from "./table";
import { Options } from "vue-class-component";


@Options({
  props: {
    reportFilter: ReportFilter
  },
})
export default class BoxTableComponent extends ReportTableComponent {

  updateHeaders() {
    let auth = storage.getSync<any>(storage.AUTH);
    if (auth) {
      this.headers.Authorization = `Bearer ${auth["access_token"]}`;
    }
  }
}